// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as CheckComponent} from './Check.svg';

import Icon, { TIconProps } from '../Icon';

export const IconCheck = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <CheckComponent/>
  </Icon>
));
